function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.804.83H3.196a.869.869 0 0 0-.866.866v16.609c0 .475.39.865.866.865h13.608c.476 0 .866-.39.866-.865V1.696a.869.869 0 0 0-.866-.866zM3.63 17.87h12.74V2.13H3.63v15.74zm9.845-13.336h-6.95a.651.651 0 0 0 0 1.3h6.95c.357 0 .65-.293.65-.65a.652.652 0 0 0-.65-.65m0 3.241h-6.95a.651.651 0 0 0 0 1.3h6.95c.357 0 .65-.292.65-.65a.652.652 0 0 0-.65-.65m0 3.24h-6.95a.652.652 0 0 0-.65.65c0 .359.292.652.65.652h6.95c.357 0 .65-.293.65-.651a.653.653 0 0 0-.65-.65m0 3.24h-6.95a.651.651 0 0 0 0 1.3h6.95c.357 0 .65-.292.65-.65a.652.652 0 0 0-.65-.65",
  fill: "#8E8E8E",
  fillRule: "evenodd"
});

var SvgNewsIcon = function SvgNewsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/news-icon.8dd4082a.svg";
export { ForwardRef as ReactComponent };